const useColumns = () => {
  const columns = [
    { Header: "ลำดับ", accessor: "id", showInFilter: false },
    { Header: "วัน เดือน ปี", accessor: "date", showInFilter: false },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: false },
    { Header: "ราคาทุน", accessor: "cost_price", showInFilter: false },
    { Header: "รายรับ", accessor: "revenue", showInFilter: false },
    { Header: "รายจ่าย", accessor: "expenditure", showInFilter: false },
    {
      Header: "กำไรจากยอดขาย",
      accessor: "profit_from_selling",
      showInFilter: false,
    },
    {
      Header: "กำไรจากดอกเบี้ย",
      accessor: "profit_from_interest",
      showInFilter: false,
    },
    {
      Header: "กำไรจากค่าปรับ",
      accessor: "profit_from_penalty",
      showInFilter: false,
    },
    { Header: "รวมกำไร", accessor: "profit_sum", showInFilter: false },
    { Header: "คงเหลือ", accessor: "remaining", showInFilter: false },
  ];

  return columns;
};

export default useColumns;
